/* eslint-disable react/prop-types */
import React from 'react'
import { Alert, AlertIcon, Box, AlertTitle, AlertDescription, CloseButton, createStandaloneToast } from '@chakra-ui/react'
import IosCloseCircle from '@meronex/icons/ios/IosCloseCircle'
import IosCheckmarkCircle from '@meronex/icons/ios/IosCheckmarkCircle'

import { theme } from '../theme'

// NOTE: overwrite icon by status
// more info: https://github.com/chakra-ui/chakra-ui/blob/master/packages/alert/src/alert.tsx#L16-L21
const STATUSES = {
  success: { icon: IosCheckmarkCircle, colorScheme: 'green' },
  error: { icon: IosCloseCircle, colorScheme: 'red' },
}

// NOTE: copy from https://github.com/chakra-ui/chakra-ui/blob/main/packages/toast/src/use-toast.tsx#L87-L124
// it will be fine to using imported component if the package exports it
export const Toast = (props) => {
  const { status, variant, id, title, isClosable, onClose, description, statuses: statusesProp, propsOf = {} } = props
  const alertTitleId = typeof id !== 'undefined' ? `toast-${id}-title` : undefined
  // value will be `undefined` then using default icon or colorScheme if not overwrited
  const statuses = React.useMemo(() => ({ ...STATUSES, ...statusesProp }), [statusesProp])

  return (
    <Alert
      colorScheme={statuses[status]?.colorScheme} // customizable colorScheme
      status={status}
      variant={variant}
      id={id}
      alignItems='start'
      borderRadius='lg'
      boxShadow='md'
      margin='0.5rem'
      paddingY='0.75rem'
      textAlign='start'
      width='auto'
      aria-labelledby={alertTitleId}
      {...propsOf.alert}
    >
      {/* customizable icon */}
      <AlertIcon as={statuses[status]?.icon} width='1.25rem' height='1.5rem' mr='1rem' {...propsOf.icon} />
      <Box flex='1' maxWidth='100%'>
        {title && (
          <AlertTitle id={alertTitleId} {...propsOf.title}>
            {title}
          </AlertTitle>
        )}
        {description && (
          <AlertDescription display='block' fontSize='sm' fontWeight='500' {...propsOf.description}>
            {description}
          </AlertDescription>
        )}
      </Box>

      {isClosable && <CloseButton size='sm' onClick={onClose} position='absolute' insetEnd='0.25rem' top='0.25rem' {...propsOf.close} />}
    </Alert>
  )
}

// if you want to use another theme and default options, you can use `createStandaloneToast` func to create another one
const defaultOptions = { position: 'top-right', duration: 5000, variant: 'solid' }
const standaloneToast = createStandaloneToast({ theme, defaultOptions })

export const toast = (options) =>
  standaloneToast({
    ...defaultOptions,
    ...options,
    // use custom toast component with custom icons instead of build-in
    render: (props) => <Toast {...props} {...defaultOptions} {...options} />,
  })
